import { gql } from '@edreamsodigeo/frontend-api-client';
import { itinerarySearchSegment } from './itinerarySearchSegment';

export const itinerarySearchItinerary = gql`
  fragment ItinerarySearchItineraryFragment on ItinerarySearchResult {
    id
    isFareUpgradeAvailable
    key
    hotelXSellingEnabled
    meRating
    fees {
      price {
        amount
        currency
      }
      type
    }
    ticketsLeft
    legs {
      segmentKeys
      segments {
        ...SegmentInfo
      }
    }
    transportTypes
    carbonFootprintId
    campaignConfigId
    perks {
      primeDiscount {
        amount
        currency
      }
      extraPrimeCoupon {
        amount
        currency
      }
      primeDiscountPerPassenger {
        amount
        currency
      }
      extraPrimeCouponPerPassenger {
        amount
        currency
      }
      alternativeItineraryDiscount {
        amount
        currency
      }
      alternativeItineraryDiscountPerPassenger {
        amount
        currency
      }
    }
  }

  ${itinerarySearchSegment}
`;
